import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

function Root() {
  return <App />;
}

root.render(<Root />);
